import { Component } from '@angular/core';
import { Platform, NavController,AlertController,MenuController, ModalController, ToastController,} from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { Router, NavigationExtras } from '@angular/router';
import { Events } from '@ionic/angular';
import { Environment } from '@ionic-native/google-maps/ngx';
import { Device } from '@ionic-native/device/ngx';
import { AllServicesService } from './all-services.service';
// import { FCM } from '@ionic-native/fcm/ngx';
import * as firebase from 'firebase';

import { CallingPage } from './calling/calling.page';
import { OneSignal } from '@ionic-native/onesignal/ngx';



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  appPages:Array<{title: string, url: any,icon:any}>;
  logout:any;
  userDetails:any;
  deviceData: any = [];
  webRTCClient:any;
  session_id:any;
  myCallId:any;
  user:any;
  showCall: boolean;
  showHangup: boolean;
  showAnswer: boolean;
  showReject: boolean;
  showStatus: boolean;
  showRemoteVideo: boolean = true;
  showMyVideo: boolean = true;
  ref1:any;
  incomingcalldata:any;
  is_login:boolean=false;

  onlineRef:any;

  online:any = 1;

   reciving:boolean=false;
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public storage:Storage,
    private router: Router,
    public events: Events,
    public navCtrl: NavController,
    public alertController:AlertController,
    public menu:MenuController,
    // private fb: Firebase,
    // private fcm: FCM,
    private oneSignal: OneSignal,
    private device: Device,
    public allServices:AllServicesService,
    public modalController: ModalController,
    public toastController: ToastController
  ) {
    // Initialize Firebase
    let config = {
      apiKey: "AIzaSyAx9wnJYz8n0NB1qnVl6EPzbDeC4_Pc2h4",
      authDomain: "lawbyphone-bcabf.firebaseapp.com",
      databaseURL: "https://lawbyphone-bcabf.firebaseio.com",
      projectId: "lawbyphone-bcabf",
      storageBucket: "lawbyphone-bcabf.appspot.com",
      messagingSenderId: "380808694790",
      appId: "1:380808694790:web:5c2afff007abae31bf0787"
    };
    firebase.initializeApp(config);

    this.initializeApp();
  }


  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();


      this.oneSignal.startInit('27499c2f-8b94-4b00-a860-8a4e14f4fd91');

      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);

      this.oneSignal.handleNotificationReceived().subscribe((notification) => {
        console.log('handleNotificationReceived',notification);
        this.storage.get('user').then(val=>{
          if(val){
            this.allServices.getNotCount(val.user_id)
              .subscribe(res => {
                let res2:any = [];
                res2 = res; 
                this.events.publish('mynoti:created', res2.my_noti_count); 
            });
          }
        });
      });

      this.oneSignal.handleNotificationOpened().subscribe(() => {
        // do something when a notification is opened
      });

      this.oneSignal.endInit();

      this.oneSignal.getIds().then((data) => {
        console.log(data);
        // console.log(`FCM Got a new token ${data.userId}`);
        localStorage.setItem('dtoken',data.userId);
      });
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });


    if(localStorage.getItem('remembarStatus') && localStorage.getItem('remembarStatus') == 'true'){
      this.storage.get('user').then(userInfo=>{
        console.log("userInfo: "+userInfo);
        if(userInfo){
          this.events.publish('userCheck:created', userInfo); 

            if(userInfo.role == 'patient'){
              this.initiateFBOnline();
              this.router.navigate(['/patientdashboard']);
            }
            else if(userInfo.role == 'doctor'){
              this.router.navigate(['/patientdashboard']);
            }
            else{
              this.directLogout();
            }

          }else{
            this.events.publish('userCheck:created', 'userNotLogin'); 
            this.router.navigate(['/login']);
          }
      });  
    }else{
      this.events.publish('userCheck:created', 'userNotLogin'); 
      this.router.navigate(['/login']);
    }
      
    this.events.subscribe('userCheck:created', (check) => { 

      this.allServices.checkingProcess();
      this.allServices.CheckMembership();

      this.logout=true;
      if(check.token){

        setTimeout(() => {
          this.initiateFB();
          if(check.role == 'patient'){
            this.initiateFBOnline();
          }
        }, 2000);

        if(check.role == 'patient'){
          this.is_login=true;
          this.appPages =[
            {
              title: 'Dashboard',
              url: '/patientdashboard',
              icon: 'home'
            },
            {
              title: 'My Account',
              url: '/myaccount',
              icon: 'person'
            },
            {
              title: 'Change Password',
              url: '/changepassword',
              icon: 'lock'
            },
            {
              title: 'FAQs',
              url: '/faqs',
              icon: 'information-circle'
            },
            {
              title: 'Privacy Policy',
              url: '/privacy-policy',
              icon: 'list'
            }
          ]
        }
        else if(check.role == 'doctor'){
          this.is_login=true;
          this.appPages =[
            {
              title: 'Dashboard',
              url: '/patientdashboard',
              icon: 'home'
            },
            {
              title: 'My Account',
              url: '/myaccount',
              icon: 'person'
            },
            {
              title: 'FAQs',
              url: '/faqs',
              icon: 'information-circle'
            },
            {
              title: 'Privacy Policy',
              url: '/privacy-policy',
              icon: 'information-circle'
            },
            // {
            //   title: 'View Form',
            //   url: '/view-form',
            //   icon: 'list'
            // }
          ]
        }
        else{
          this.appPages =[];
        }

      }
      if(check == 'userNotLogin'){
        this.is_login=false;
        this.logout=false;
        this.appPages= [
          {
            title: 'Sign In',
            url: '/login',
            icon: 'list'
          },
          {
            title: 'Sign Up',
            url: '/signup',
            icon: 'list'
          }
        
        ]
      }
    });

  }

  initiateFB(){
    this.storage.get('user').then(val=>{
      if(val!=null){
        this.user=val;
        this.ref1 = firebase.database().ref('call/'+val.user_id);
        if(this.ref1){
          this.ref1.limitToLast(1).on('value',data1 => {
            if(data1.val()==null){
              this.reciving=false;
            }else{
            let callData = {};
            console.log('data 1 : ', data1);
            data1.forEach( data => {
              if(data.val()){
                console.log('data 3 : ', data.val());
                callData = {
                  caller_id: data.val().caller_id,
                  caller_name: data.val().caller_name,
                  caller_img: data.val().caller_img,
                  caller_role: data.val().caller_role,
                  appointment_id: data.val().appointment_id,
                  session_id: data.val().session_id,
                  token: data.val().token,
                  status: data.val().status
                };
                // this.ref1.remove();
                if(callData['status']==0 && this.reciving==false ){
                     this.reciving=true;
                     this.callModal(callData);
                }

                if(data.val().recording==0){
                  this.presentAlertConfirm(data);
                }
                
              }
            });
          }
          });
        }
        else{
          console.log("I AM IN ERROR!!");
        }
      }
    });      
  } 

  async presentAlertConfirm(data) {
    this.incomingcalldata=data;
    const alert = await this.alertController.create({
      header: 'Confirm!',
      message: 'Please allow us for recording ?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            let update = firebase.database().ref('call/' + this.user.user_id + '/' + this.incomingcalldata.key).update({ recording: 2 });
            if (update) {
              console.log('Confirm Okay');
            }
          }
        }, {
          text: 'Yes',
          handler: () => {
            let update = firebase.database().ref('call/' + this.user.user_id + '/' + this.incomingcalldata.key).update({ recording: 1 });
            if (update) {
              console.log('Confirm Okay');
            }
           
          }
        }
      ]
    });

    await alert.present();
  }

  initiateFBOnline(){

    console.log("M HERE");
    this.platform.ready().then(() => {  
      
      this.storage.get('user').then(val=>{
        if(val){
          this.onlineRef = firebase.database().ref('online_users/'+val.user_id);
          if(this.onlineRef){
            this.onlineRef.push({
              online: 1
            });

            // window.addEventListener('beforeunload', () => {
            //   this.onlineRef.remove();
            // });

            // Observable.fromEvent(window, 'beforeunload').subscribe(event: Event => this.unsubscribeFromSignals());

              this.platform.pause.subscribe(async () => {
                console.log('Pause event detected');
                this.onlineRef.remove();
              });

              this.platform.resume.subscribe(async () => {
                console.log('Resume event detected');
                this.onlineRef.push({
                  online: 1
                });
              });
  
          }
          else{
            console.log("I AM IN ERROR!!");
          }
        }
      });
  
   });  
  }

  async callModal(callData) {
    // this.ref1.off();
    const modal = await this.modalController.create({
      component: CallingPage,
      cssClass: 'full-modal',
      componentProps: {
        "data": JSON.stringify(callData)
      }
    });
    modal.onDidDismiss().then((dataReturned) => {
      if (dataReturned !== null) {
      }
    });
    return await modal.present();
  }

  async DoLogout() {
    let alert = await this.alertController.create({
      header: 'Alert',
      message: "Are you sure?",
      buttons: [
        {
          text: 'Yes',
          handler: () => {

            this.storage.get('user').then((val) => {
              if(val!=null){
                let user_id = val.user_id;
                
                this.removeToken(user_id);
                if(this.onlineRef){
                  this.onlineRef.remove();
                }
                if(this.ref1){
                  this.ref1.off();
                }
                
              }
            });

            this.storage.clear();
            this.storage.remove('user');
            this.events.publish('userCheck:created', 'userNotLogin'); 
            this.events.publish('user_login', {key: 'value'});
            this.router.navigate(['']);
          }
        },
        {
          text: 'No',
          role: 'cancel',
          handler: () => {

          }
        }
      ],
      cssClass: 'comment-alert'
    });

    await alert.present();
  }
  directLogout(){
    this.storage.get('user').then((val) => { 
      if(val!=null){
        let user_id = val.user_id;
        
        this.removeToken(user_id);
        if(this.onlineRef){
          this.onlineRef.remove();
        }
        if(this.ref1){
          this.ref1.off();
        }
      }
    });

    this.storage.clear();
    this.storage.remove('user');
    this.events.publish('userCheck:created', 'userNotLogin'); 
    this.events.publish('user_login', {key: 'value'});
    this.router.navigate(['']);
  }
  removeToken(user_id) {
    this.deviceData.push({
        uuid: this.device.uuid,
        model: this.device.model,
        platform: this.device.platform,
        version: this.device.version,
    });
    this.allServices.updateToken(user_id, '', this.deviceData, 'logout')
      .subscribe(res => {
          console.log(res);
      });
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      animated: true,
      // cssClass: "my-toast-red",
      duration: 3000
    });
    toast.present();
  }
  
}
